import * as defaults from '../defaults';
import { getLineHeightInPx } from '../inject-missing-props-into-html';
import { toMobileFontSize } from '../font-utils/to-mobile-font-size';
import { getMobileLineHeightClassName } from './get-mobile-line-height-class-name';
import { extractValuesFromHtml } from './html';
var lineHeightExtractor = function (css) { return function ($) {
    return defaults.defaultContainerElements
        .map(function (e) {
        return $(e)
            .map(function (_id, el) { return getLineHeightInPx($(el), { css: css }); })
            .get()
            .map(toMobileFontSize);
    })
        .reduce(function (acc, curr) { return acc.concat(curr); }, []);
}; };
export var getMobileLineHeightClasses = function (htmls, _a) {
    var composerData = _a.composerData;
    return extractValuesFromHtml(htmls, lineHeightExtractor(composerData.styles.css))
        .map(function (lineHeight) {
        return ".".concat(getMobileLineHeightClassName(lineHeight), "{line-height: ").concat(lineHeight, "px !important;}");
    })
        .join(' ');
};
//# sourceMappingURL=get-mobile-line-height-classes.js.map